module.exports = __webpack_public_path__ + "img/cup.2bf1e6a4.svg";